// PlantForm.js
import React, { useState } from 'react';
import './PlantForm.css';   // ← create this file (you can copy & rename VehicleForm.css)

const PlantForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    plant_name: '',
    address: '',
    contact_name: '',
    contact_number: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/plants.php`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          action: 'create'   // if your backend expects this field
        })
      });

      const data = await response.json();

      if (data.success) {
        setSuccess('Plant added successfully!');
        setTimeout(() => {
          onClose(true);
        }, 1500);
      } else {
        setError(data.message || 'Failed to add plant');
      }
    } catch (err) {
      setError('Error connecting to server');
      console.error('Submit error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vehicle-form">   {/* reusing same class name → consistent look */}
      <div className="form-header">
        <h2>Add New Plant</h2>
        <button className="btn-close" onClick={() => onClose(false)}>×</button>
      </div>

      {error && (
        <div className="alert alert-danger">
          <span>❌</span> {error}
        </div>
      )}

      {success && (
        <div className="alert alert-success">
          <span>✅</span> {success}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="plant_name">
            Plant Name *
            <span className="hint">(e.g. Jamshedpur Plant, Mumbai Depot)</span>
          </label>
          <input
            type="text"
            id="plant_name"
            name="plant_name"
            value={formData.plant_name}
            onChange={handleChange}
            placeholder="Enter plant / facility name"
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Full Address</label>
          <textarea
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Street, City, State, PIN"
            rows={3}
            disabled={loading}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="contact_name">Contact Person</label>
            <input
              type="text"
              id="contact_name"
              name="contact_name"
              value={formData.contact_name}
              onChange={handleChange}
              placeholder="e.g. Ramesh Kumar"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact_number">Contact Number</label>
            <input
              type="tel"
              id="contact_number"
              name="contact_number"
              value={formData.contact_number}
              onChange={handleChange}
              placeholder="e.g. 94311 12345"
              disabled={loading}
            />
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={() => onClose(false)}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Adding...
              </>
            ) : 'Add Plant'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PlantForm;